import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useRestaurantsService } from '@restworld/data-services';
import { OccupationTemplate } from '@restworld/utility-types';

import { useEmployerRestaurantDetails } from './use-employer-restuarant-details';

export const useRestaurantOccupationTemplatesQuery = () => {
  const restaurantService = useRestaurantsService();
  const queryKey = useQueryKey();
  useQuery({
    queryKey: queryKey,
    queryFn: async () => (await restaurantService.fetchOccupationTemplates(queryKey[1])).data?.data,
    enabled: !!queryKey[1],
  });
};
const useQueryKey = () => {
  const employerRestaurantDetails = useEmployerRestaurantDetails();
  const restaurantId = employerRestaurantDetails?.id;
  return ['restaurant-occupation-templates', restaurantId];
};
export const useRestaurantOccupationTemplates = () => {
  const queryKey = useQueryKey();
  const restaurantOccupationTemplates = useQueryClient().getQueryData<OccupationTemplate[]>(queryKey);
  return restaurantOccupationTemplates;
};
